import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import i18n from 'i18n';

class Content extends React.Component {
  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <ul className="terms-ul">
          {i18n.t('terms:terms', { returnObjects: true }).map((item, i) => (
            <li key={i} className="row">
              <p className="title">{item.title}</p>
              <p>{item.detail}</p>
            </li>
          ))}
        </ul>
        <ul className="end-of-terms">
          <li>{i18n.t('terms:endOfTerms.publisher')}</li>
          <li>{i18n.t('terms:endOfTerms.contactHeader')}</li>
          <li>{i18n.t('terms:endOfTerms.contact')}</li>
          <li>{i18n.t('terms:endOfTerms.dateOfEnforcement')}</li>
          <li>{i18n.t('terms:endOfTerms.end')}</li>
        </ul>
      </div>
    );
  }
}

const commonStyle = css`
  .terms-ul {
    list-style: none;
    padding: 0;
    color: ${Colors.black1};
    margin: 0;

    p {
      ${FontStyles.text8};

      margin: 0;
      white-space: pre-line;
    }

    li:nth-child(1) .title {
      padding-top: 0;
    }
  }

  .end-of-terms {
    ${FontStyles.text8};

    list-style: none;
    text-align: right;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .terms-ul {
    padding: 48px 0 0 0

    .title {
      ${FontStyles.text5};

      padding: 32px 0 7px 0;
    }
  }

  .end-of-terms {
    margin: 56px 0 160px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .terms-ul {
    padding: 32px 0 0 0

    .title {
      ${FontStyles.text5};

      padding: 24px 0 5px 0;
    }
  }

  .end-of-terms {
    margin: 28px 0 48px;
  }
`;

export default applyStyles(Content)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Terms/components/Content.js